// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1872) return "static/chunks/1872.fa7b9b631c2651ae.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1359":"4addaaf1977e033b","6485":"9cb393c22b77e1a9","8976":"6d730ef328c228b9"}[chunkId] + ".js";
};